import { useLocalObservable, observer } from 'mobx-react-lite'

import HeaderContainer from './components/HeaderContainer'
import ExpandContent from './components/ExpandContent'

import { useEffect } from 'react'
import RxChangeModel from 'models/Provider/RxChangesCollection/RxChange'

type RxChangeProps = {
  rxChange: RxChangeModel
}

const RxChange = ({ rxChange }: RxChangeProps) => {
  const store = useLocalObservable(() => ({
    isOpen: false,
    setIsOpen(flag) {
      this.isOpen = flag
    },
    toggleIsOpen() {
      this.isOpen = !this.isOpen
    },
  }))

  useEffect(() => {
    rxChange?.getDetails()
  }, [rxChange?.getDetails])

  return (
    <div className="shadow-[0_8px_24px_0px_rgba(170,170,170,0.25)] rounded-2xl bg-white p-6 border border-neutral-200 lg:max-w-[680px]">
      <HeaderContainer
        isOpen={store.isOpen}
        toggleIsOpen={store.toggleIsOpen}
        fullName={rxChange.patientFullName}
        age={rxChange.patientAge}
        medicationName={rxChange.medicationName}
        medicationUnit={rxChange.medicationUnit}
        medicationDirections={rxChange.medicationDirections}
        quantity={rxChange.medicationQuantity}
        refills={rxChange.medicationRefills}
        daysSupply={rxChange.medicationDaysSupply}
        address={rxChange.patientAddress}
        state={rxChange.patientState}
        phone={rxChange.patientPhone}
        gender={rxChange.patientGender}
        dob={rxChange.patientDob}
        height={rxChange.patientHeight}
        weight={rxChange.patientWeight}
        isReady={!!rxChange.prescribedMedication}
      />

      {store.isOpen && (
        <ExpandContent
          title={rxChange.prescriberFullName}
          address={rxChange.prescriberFullAddress}
          phone={rxChange.prescriberPhone}
          medication={rxChange.medicationName}
          directions={rxChange.medicationDirections}
          notes={rxChange.medicationNotes}
          unit={rxChange.medicationUnit}
          substitutions={rxChange.medicationSubstitutions}
          writtenDate={rxChange.medicationWrittenDate}
          quantity={rxChange.medicationQuantity}
          refills={rxChange.medicationRefills}
          daysSupply={rxChange.medicationDaysSupply}
          requestedMedications={rxChange.requestedMedicationsList}
          isPriorAuthType={rxChange.isPriorAuthType}
          isPrescriberAuthType={rxChange.isPrescriberAuthType}
          showPrescriberLicenseInactiveCheckbox={rxChange.showPrescriberLicenseInactiveCheckbox}
          putApproveChangeRequest={rxChange.putApproveChangeRequest}
          putDenyChangeRequest={rxChange.putDenyChangeRequest}
          prescriberAuthorizationDataType={rxChange.prescriberAuthorizationDataType}
          prescriberAuthorizationDataLabel={rxChange.prescriberAuthorizationDataLabel}
          pharmacy={rxChange.pharmacy}
          prescribedMedication={rxChange.prescribedMedication}
        />
      )}
    </div>
  )
}

export default observer(RxChange)
